import PropTypes from 'prop-types'
import classnames from 'classnames'

import Modal from '../../common/Modal'
import Input from '../../common/form/Input'
import mobilePairings from '../../../assets/images/mock/mobile-pairings.webp'

import classes from './PublishPairingsModal.module.scss'
import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'

const text = 'Are you sure you want to submit\
\nscores, the following will happen:\
\n\n  1. Your Golfers will be emailed\
\n\n  2. Pairings will show up in the mobile app in the schedule\
\n\n  3. RSVP window will close'

const DESCRIPTION_MAX_LENGTH = 400

const PublishPairingsModal = ({ showModal, closeModal, submitButton, secondButton, extraContent, emailMessage, handleMessageChange }) => (
  <Modal
    isOpen={showModal}
    onClose={closeModal}
    contentLabel='Publish Pairings Modal'
    className={classes['modal']}
    autoFocus
  >
    <div className={classes['wrapper']}>
      <div className='d-flex align-items-end'>
        <div className={classes['text-content']}>
          <div className={classnames('d-flex align-items-center', classes['title-container'])}>
            <div className={classnames('d-flex justify-content-center align-items-center', classes['icon-wrapper'])}>
              <GolferIcon className={classes['golfer-icon']} fill='#fff' width={'30px'} height={'30px'} />
            </div>
            <span className={classes['title']}>Publish Pairings</span>
          </div>
          <div className={classes['text-container']}>{text}</div>
          <div className={classnames('mt-3', classes['text-container'])}>{extraContent}</div>
        </div>
        <div className={classnames('d-flex justify-content-end', classes['image'])}>
          <img className={classes['mobile-leaderboard']} src={mobilePairings} alt='mobile leaderboard' />
        </div>
      </div>
      <div className='mt-3'>
        <span className={classes.secondaryText}>Leave a custom message for the participants in the email:</span>
        <div className='mt-3'>
          <Input
            name='emailMessage'
            type='textarea'
            onChange={handleMessageChange}
            placeholder='Type your message here'
            value={emailMessage}
            maxLength={DESCRIPTION_MAX_LENGTH}
            styles={{ inputContainer: { height: '150px' } }}
          />
          <p className={classes.characterCounter}>
            {`${emailMessage?.length}/${DESCRIPTION_MAX_LENGTH} characters`}
          </p>
        </div>
      </div>
      {submitButton}
      {secondButton}
    </div>
  </Modal>
)

PublishPairingsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  submitButton: PropTypes.object,
  secondButton: PropTypes.object,
  extraContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  emailMessage: PropTypes.string,
  handleMessageChange: PropTypes.func,
}

export default PublishPairingsModal
